import React from 'react'
import {ImagePicker, VideoPicker} from '../../components/Letflow/Form';
import localization from '../../config/localization';
import {TextValidator} from "react-material-ui-form-validator";
import {Checkbox, Dialog, DialogContent, FormControlLabel, FormLabel, IconButton} from "@material-ui/core";
import TranslatableInputs from "../../components/Letflow/TranslatableInputs";
import FormTagSelection from "../../components/Letflow/Form/FormTagSelection";
import FilePondUploader from "../../components/Letflow/FilePondUploader";
import 'filepond/dist/filepond.min.css';
import {FormControl, Radio, RadioGroup} from "@material-ui/core/index";
import AsyncSelect from "react-select/lib/Async";
import {request} from "../../api-client";
import Pdf from "../../assets/img/Letflow/FileExtentions/pdf.png";
import {CloudDownload, Event} from "@material-ui/icons";
import {DateTimePicker, MuiPickersUtilsProvider} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import {ErrorMessage} from "formik";
import Unsplash from "../../components/Letflow/Unsplash";

const FormContent = ({
  id,
  titleEs,
  titleEn,
  titlePt,
  subtitle,
  active,
  descriptionEs,
  descriptionEn,
  descriptionPt,
  video,
  onChange,
  onVideoChange,
  disabled,
  onActiveChange,
  image,
  onImageChange,
  tagGroups,
  onSelectedTagsChanged,
  audio,
  onAudioChange,
  binary,
  onBinaryChange,
  link,
  onSetPreview,
  updateDisableForm,
  disableForm,
  videosRadio,
  imagesRadio,
  audiosRadio,
  onBatchRadiosChange,
  onBatchVideoLinkChange,
  selectedBatchVideoLink,
  onBatchVideoFileChange,
  selectedBatchVideoFile,
  onBatchImageLinkChange,
  selectedBatchImageLink,
  onBatchImageFileChange,
  selectedBatchImageFile,
  onBatchAudioLinkChange,
  selectedBatchAudioLink,
  onBatchAudioFileChange,
  selectedBatchAudioFile,
  isTalent,
  fileSelector,
  onRadioChange,
  subtitles,
  onSubtitlesChange,
  spanishSubtitles,
  englishSubtitles,
  onCheckBoxChange,
  spanishSubtitlesFile,
  englishSubtitlesFile,
  italianSubtitles,
  italianSubtitlesFile,
  germanSubtitles,
  germanSubtitlesFile,
  frenchSubtitles,
  frenchSubtitlesFile,
  releaseDate,
  expireDate,
  hasExpiredDate,
  onHasExpiredDateChange,
  isPermanentContent,
  onIsPermanentContentChange,
  embedUrl,
  embedSource,
  downloadable,
  onlyArgentina,
  onChangeOnlyArgentina,
  onSetImageFromUnsplash,
  requireDrm,
  requireLogin,
  showRequireLoginHelper,
  updateHelper,
  unsplashImage,
  hasPreRoll,
  onBatchPreRollVideoLinkChange,
  selectedBatchPreRollVideoLink,
  onBatchPreRollVideoFileChange,
  selectedBatchPreRollVideoFile,
  preRollVideo,
  showDRMDialog,
  updateDRMDialog,
  onLimitedChange,
  limited,
  viewLimit,
  timeToTrack,
  metadata,
  weight
}) => {
  return (
    <div>
      <Dialog open={showRequireLoginHelper} onBackdropClick={updateHelper} onEscapeKeyDown={updateHelper}>
        <DialogContent>
          <p>{localization.get('content_creation.require_login_helper')}</p>
        </DialogContent>
      </Dialog>
      <Dialog open={showDRMDialog} onBackdropClick={updateDRMDialog} onEscapeKeyDown={updateDRMDialog}>
        <DialogContent>
          {(image && !image.src) && !selectedBatchImageFile && !unsplashImage ?
            <p>{localization.get('content_creation.require_login_helper')}</p>
            :
            <p>{localization.get(requireLogin && requireDrm ? 'content_creation.drm_helper_disabled' : 'content_creation.drm_helper_unable')}</p>
          }
        </DialogContent>
      </Dialog>
      <TranslatableInputs
        children={[
          {
            language: 'es',
            content: [
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="titleEs"
                label={localization.get('form.title')}
                name="titleEs"
                value={titleEs}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="descriptionEs"
                label={localization.get('form.description')}
                name="descriptionEs"
                value={descriptionEs}
                onChange={onChange}
                disabled={disabled}
                multiline
              />
            ]
          },
          {
            language: 'en',
            content: [
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="titleEn"
                label={localization.get('form.title')}
                name="titleEn"
                value={titleEn}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="descriptionEn"
                label={localization.get('form.description')}
                name="descriptionEn"
                value={descriptionEn}
                onChange={onChange}
                disabled={disabled}
                multiline
              />
            ]
          },
          {
            language: 'pt',
            content: [
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="titlePt"
                label={localization.get('form.title')}
                name="titlePt"
                value={titlePt}
                onChange={onChange}
                disabled={disabled}
                validators={['required']}
                errorMessages={[localization.get('validator.is_required')]}
              />,
              <TextValidator
                style={{width: "100%", marginBottom: "20px"}}
                id="descriptionPt"
                label={localization.get('form.description')}
                name="descriptionPt"
                value={descriptionPt}
                onChange={onChange}
                disabled={disabled}
                multiline
              />
            ]
          }
        ]}
      />
      <TextValidator
        style={{width: "100%", marginBottom: "20px"}}
        id="subtitle"
        label={localization.get('form.subtitle')}
        name="subtitle"
        value={subtitle}
        onChange={onChange}
        disabled={disabled}
        errorMessages={[localization.get('validator.is_required')]}
      />
      <React.Fragment>
        <br/>
        <br/>
        <TextValidator
          style={{width: "100%"}}
          id="weight"
          label={localization.get("form.weight")}
          helperText={localization.get("form.weight_helper")}
          InputProps={{inputProps: {min: 0, max: 999}}}
          type={"number"}
          onChange={onChange}
          name="weight"
          value={weight}
          onInput={(e) => {
            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3)
          }}
        />
      </React.Fragment>

      <h4>{localization.get('form.material_program')}</h4>
      <div style={{marginTop: 10}}>
        <FormControl>
          <RadioGroup
            name="active"
            id="active"
            value={active}
            onChange={e => onActiveChange(e.target.value)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="1" control={<Radio color="default"/>} label={localization.get('form.allowed_material')}/>
            <FormControlLabel value="0" control={<Radio color="default"/>} label={localization.get('form.disallowed_material')}/>
          </RadioGroup>
        </FormControl>
      </div>

      {active === "1" && !isTalent &&
      <>
        <div>{localization.get('form.material_duration')}</div>
        <FormControl>
          <RadioGroup
            name="isPermanentContent"
            value={isPermanentContent}
            onChange={e => onIsPermanentContentChange(e.target.value)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="1" control={<Radio color="default"/>}
                              label={localization.get('form.permanent_material')}/>
            <FormControlLabel value="0" control={<Radio color="default"/>}
                              label={localization.get('form.not_permanent_material')}/>
          </RadioGroup>
        </FormControl>
        {isPermanentContent === "0" &&
        <div style={{width: "50%", display: "flex", flexDirection: "column", marginTop: 10}}>
          <div>{localization.get('form.range_disponibility')}</div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimePicker
              style={{marginBottom: 15}}
              autoOk
              autoSubmit
              disablePast
              format={"dd/MM/yyyy HH:mm a"}
              helperText={localization.get("form.helper_datepicker_material_active")}
              dateRangeIcon={<Event/>}
              id={"releaseDate"}
              defaultValue={releaseDate}
              label={localization.get('form.release_date')}
              value={releaseDate}
              onChange={e => {
                onChange({
                  target: {
                    id: "releaseDate",
                    value: e,
                  }
                })
              }}
            />
            <ErrorMessage name="startTime" className="web-like-error">
              {msg => <div className="web-like-error font12">{msg}</div>}
            </ErrorMessage>
          </MuiPickersUtilsProvider>
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={!hasExpiredDate}
                onChange={() => onHasExpiredDateChange(!hasExpiredDate)}
              />
            }
            label={localization.get('has_expired_date')}
          />
          {hasExpiredDate &&
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DateTimePicker
              autoOk
              clearable
              onlyCalendar
              id={"expireDate"}
              disablePast
              defaultValue={expireDate}
              dateRangeIcon={<Event/>}
              format={"dd/MM/yyyy HH:mm a"}
              disabled={!hasExpiredDate}
              label={localization.get('form.expire_date')}
              helperText={localization.get("form.helper_datepicker_material_disactive")}
              value={expireDate}
              onChange={e => {
                onChange({
                  target: {
                    id: "expireDate",
                    value: e,
                  }
                })
              }}
            />
          </MuiPickersUtilsProvider>
          }
        </div>
        }
      </>
      }
      {!id &&
      <FormControl>
        <FormLabel style={{color: 'black'}} focused={false}>{localization.get('creation.select')}</FormLabel>
        <RadioGroup
          name="fileSelector"
          value={fileSelector}
          onChange={e => onRadioChange(e)}
          style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
        >
          <FormControlLabel value="video" control={<Radio color="default"/>} label={localization.get('creation.videos_file')}/>
          <FormControlLabel value="audio" control={<Radio color="default"/>} label={localization.get('creation.audios_file')}/>
          <FormControlLabel value="image" control={<Radio color="default"/>} label={localization.get('creation.images_file')}/>
          <FormControlLabel value="binary" control={<Radio color="default"/>} label={localization.get('creation.pdf_file')}/>
          <FormControlLabel value="link" control={<Radio color="default"/>} label={localization.get('creation.link')}/>
          <FormControlLabel value="embed" control={<Radio color="default"/>} label={localization.get('form.embed')}/>
        </RadioGroup>
      </FormControl>
      }

      {fileSelector === "video" || fileSelector === "image" &&
      <div>
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={downloadable}
              onChange={() => {
                onCheckBoxChange('downloadable', !downloadable);
              }}
            />
          }
          label={localization.get("form.downloadable_material")}
        />
      </div>
      }


      {fileSelector !== "default" &&
      <>
        <h4>{localization.get('image')}</h4>
        <FormControl>
          <RadioGroup
            name="imagesRadio"
            value={imagesRadio}
            onChange={e => onBatchRadiosChange(e)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="filepond" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_computer')}/>
            <FormControlLabel value="batch" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_platform')}/>
            <FormControlLabel value="unsplash" control={<Radio color="default"/>}
                              label={localization.get('form.upload_from_unsplash')}/>
          </RadioGroup>
        </FormControl>

        {imagesRadio === 'filepond' ?
          <>
            {(image && image.src) && <ImagePicker image={image.src} previewOnly={true}/>}
            {image && image.id &&
            <div style={{textAlign: 'center'}}>
              <IconButton
                title={localization.get('download')}
                onClick={() => {
                  request.file.image.getDownloadLink(image.id)
                    .then(link => window.open(link, '_blank'))
                }}
              >
                <CloudDownload/>
              </IconButton>
            </div>
            }
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              file={image}
              id={"image"}
              type={"image"}
              allowedTypes={["image/*"]}
              onIdChange={onImageChange}
              setPreview={onSetPreview}
            />
            <div style={{
              color: "#757575",
              textAlign: 'center',
              marginTop: 5
            }}>{localization.get('helper_text.images_width_2048')}</div>
          </>
          : imagesRadio === 'unsplash' ?
            <Unsplash imageAmount={9} onSelectImage={onSetImageFromUnsplash}/>
            :
            <>
              <FormControl fullWidth>
                <span>{localization.get('batch_upload.form.select_batch_upload_link')}</span>
                <AsyncSelect
                  styles={{menu: base => ({...base, zIndex: 10})}}
                  theme={theme => ({...theme, borderRadius: 0})}
                  placeholder={localization.get('conversation.filter_users')}
                  loadingMessage={() => localization.get('loading')}
                  noOptionsMessage={() => localization.get('no_options')}
                  onChange={onBatchImageLinkChange}
                  value={selectedBatchImageLink}
                  loadOptions={inputValue => {
                    let filterBy = [{column: "name", filter: inputValue}, {column: "is_talent", filter: isTalent}];

                    return request.batchUpload.getAll({orderBy: {column: "name", type: "ASC"}, filterBy})
                      .then(links => links.map(link => ({value: link.id, label: link.name, token: link.token})))
                  }}
                  defaultOptions
                />
              </FormControl>

              {selectedBatchImageLink &&
              <FormControl style={{marginTop: 20}} fullWidth>
                <span>{localization.get('batch_upload.form.select_batch_upload_file')}</span>
                <AsyncSelect
                  styles={{
                    menu: base => ({
                      ...base,
                      zIndex: 10
                    })
                  }}
                  theme={theme => ({
                    ...theme,
                    borderRadius: 0
                  })}
                  placeholder={localization.get('conversation.filter_users')}
                  loadingMessage={() => localization.get('loading')}
                  noOptionsMessage={() => localization.get('no_options')}
                  onChange={onBatchImageFileChange}
                  value={selectedBatchImageFile}
                  loadOptions={inputValue => {
                    let filterBy = [{column: "filename", filter: inputValue}, {column: "type", filter: 'image'}];

                    return request.batchUpload.getAllFiles({
                      orderBy: {column: "created_at", type: "DESC"},
                      filterBy
                    }, selectedBatchImageLink.token)
                      .then(files => files.map(file => ({value: file.id, label: file.filename})))
                  }}
                  defaultOptions
                />
              </FormControl>
              }
            </>
        }


        <br/>
        <br/>
      </>
      }
      {fileSelector === "video" &&
      <>
        <h4>{localization.get('video')}</h4>
        <FormControl>
          <RadioGroup
            name="videosRadio"
            value={videosRadio}
            onChange={e => onBatchRadiosChange(e)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="filepond" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_computer')}/>
            <FormControlLabel value="batch" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_platform')}/>
          </RadioGroup>
        </FormControl>

        {videosRadio === 'filepond' ?
          <>
            {video.src && <VideoPicker video={video.src} previewOnly={true}/>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              file={video}
              id={"video"}
              type={"video"}
              allowedTypes={["video/mp4", "video/x-m4v", "video/*", ".mov"]}
              onIdChange={onVideoChange}
              setPreview={onSetPreview}
            />
          </>
          :
          <>
            <FormControl fullWidth>
              <span>{localization.get('batch_upload.form.select_batch_upload_link')}</span>
              <AsyncSelect
                styles={{
                  menu: base => ({
                    ...base,
                    zIndex: 10
                  })
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0
                })}
                placeholder={localization.get('conversation.filter_users')}
                loadingMessage={() => localization.get('loading')}
                noOptionsMessage={() => localization.get('no_options')}
                onChange={onBatchVideoLinkChange}
                value={selectedBatchVideoLink}
                loadOptions={inputValue => {
                  let filterBy = [{column: "name", filter: inputValue}, {column: "is_talent", filter: isTalent}];

                  return request.batchUpload.getAll({orderBy: {column: "name", type: "ASC"}, filterBy})
                    .then(links => links.map(link => ({value: link.id, label: link.name, token: link.token})))
                }}
                defaultOptions
              />
            </FormControl>

            {selectedBatchVideoLink &&
            <FormControl style={{marginTop: 20}} fullWidth>
              <span>{localization.get('batch_upload.form.select_batch_upload_file')}</span>
              <AsyncSelect
                styles={{
                  menu: base => ({
                    ...base,
                    zIndex: 10
                  })
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0
                })}
                placeholder={localization.get('conversation.filter_users')}
                loadingMessage={() => localization.get('loading')}
                noOptionsMessage={() => localization.get('no_options')}
                onChange={onBatchVideoFileChange}
                value={selectedBatchVideoFile}
                loadOptions={inputValue => {
                  let filterBy = [{column: "filename", filter: inputValue}, {column: "type", filter: 'video'}];

                  return request.batchUpload.getAllFiles({
                    orderBy: {column: "created_at", type: "DESC"},
                    filterBy
                  }, selectedBatchVideoLink.token)
                    .then(files => files.map(file => ({value: file.id, label: file.filename})))
                }}
                defaultOptions
              />
            </FormControl>
            }
            <br/>
            <br/>
          </>
        }
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={!!requireLogin}
              onChange={() => {
                if ((image && !image.src) && !selectedBatchImageFile && !unsplashImage) {
                  updateHelper()
                } else if (requireLogin && requireDrm) {
                  updateDRMDialog()
                } else {
                  onCheckBoxChange('requireLogin', !requireLogin)
                }
              }}
            />
          }
          label={localization.get('form.require_login')}
        />
        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={requireDrm}
              onChange={() => {
                if (!requireDrm && (!requireLogin || ((image && !image.src) && !selectedBatchImageFile && !unsplashImage))) {
                  updateDRMDialog()
                } else {
                  onCheckBoxChange('requireDrm', !requireDrm);
                }
              }}
            />
          }
          label={localization.get('form.require_drm')}
        />

        <FormControlLabel
          control={
            <Checkbox
              style={{color: "#4cc2d5"}}
              checked={hasPreRoll}
              onChange={() => {
                onCheckBoxChange('hasPreRoll', !hasPreRoll);
              }}
            />
          }
          label={localization.get('form.pre_roll')}
        />
        {active === "1" && !isTalent &&
        <>
          <div style={{marginTop: 10}}>
            <div>{localization.get('form.region')}</div>
            <FormControl>
              <RadioGroup
                name="onlyArgentina"
                value={onlyArgentina}
                onChange={e => {
                  if ((image && !image.src) && !selectedBatchImageFile && !unsplashImage) {
                    updateHelper()
                  }else{
                    onChangeOnlyArgentina(e.target.value)
                  }
                }}
                style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
              >
                <FormControlLabel value="0" control={<Radio color="default"/>} label={localization.get('form.all_world')}/>
                <FormControlLabel value="1" control={<Radio color="default"/>}
                                  label={localization.get('form.only_argentina')}/>
              </RadioGroup>
            </FormControl>
          </div>
          <div style={{marginTop: 10}}>
            <div>{localization.get('form.limit_views')}</div>
            <FormControl>
              <RadioGroup
                name="limited"
                id="limited"
                value={limited}
                onChange={e => {
                  if ((image && !image.src) && !selectedBatchImageFile && !unsplashImage) {
                    updateHelper()
                  }else{
                    onLimitedChange(e.target.value)
                  }
                }}
                style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
              >
                <FormControlLabel value="0" control={<Radio color="default"/>}
                                  label={localization.get('form.disabled')}/>
                <FormControlLabel value="1" control={<Radio color="default"/>}
                                  label={localization.get('form.active')}/>
              </RadioGroup>
            </FormControl>
          </div>
          {limited === "1" &&
          <FormControl style={{marginTop: 20}} fullWidth>
            <TextValidator
              style={{width: "100%", marginBottom: "20px"}}
              label={localization.get('form.view_limit')}
              name="viewLimit"
              id="viewLimit"
              type={"number"}
              maxLength="3"
              min="0"
              value={viewLimit}
              onChange={onChange}
            />
            <TextValidator
              style={{width: "100%", marginBottom: "20px"}}
              label={localization.get('form.time_to_track')}
              name="timeToTrack"
              id="timeToTrack"
              type={"number"}
              maxLength="3"
              min="0"
              value={timeToTrack}
              onChange={onChange}
            />
          </FormControl>
          }
        </>
        }


        {/*---------------Subtitles---------------*/}
        <div>
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={subtitles}
                onChange={() => {
                  onCheckBoxChange('subtitles', !subtitles);
                }}
              />
            }
            label={localization.get("form.subtitles")}
          />
        </div>

        {subtitles &&
        <>
          {/*Spanish*/}
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={spanishSubtitles}
                onChange={() => {
                  onCheckBoxChange('spanishSubtitles', !spanishSubtitles);
                }}
              />
            }
            label={localization.get("form.spanish")}
          />

          {spanishSubtitles &&
          <>
            {spanishSubtitlesFile && <span>{spanishSubtitlesFile.filename}</span>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              id={"spanishSubtitles"}
              type={"other"}
              customProp={'text/vtt'}
              onIdChange={file => onSubtitlesChange('spanishSubtitlesId', file)}
              setPreview={onSetPreview}
            />
          </>
          }

          {/*English*/}
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={englishSubtitles}
                onChange={() => {
                  onCheckBoxChange('englishSubtitles', !englishSubtitles);
                }}
              />
            }
            label={localization.get("form.english")}
          />

          {englishSubtitles &&
          <>
            {englishSubtitlesFile && <span>{englishSubtitlesFile.filename}</span>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              id={"englishSubtitles"}
              type={"other"}
              customProp={'text/vtt'}
              onIdChange={file => onSubtitlesChange('englishSubtitlesId', file)}
              setPreview={onSetPreview}
            />
          </>
          }

          {/*Italian*/}
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={italianSubtitles}
                onChange={() => {
                  onCheckBoxChange('italianSubtitles', !italianSubtitles);
                }}
              />
            }
            label={localization.get("form.language.italian")}
          />

          {italianSubtitles &&
          <>
            {italianSubtitlesFile && <span>{italianSubtitlesFile.filename}</span>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              id={"italianSubtitles"}
              type={"other"}
              customProp={'text/vtt'}
              onIdChange={file => onSubtitlesChange('italianSubtitlesId', file)}
              setPreview={onSetPreview}
            />
          </>
          }

          {/*German*/}
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={germanSubtitles}
                onChange={() => {
                  onCheckBoxChange('germanSubtitles', !germanSubtitles);
                }}
              />
            }
            label={localization.get("form.language.german")}
          />

          {germanSubtitles &&
          <>
            {germanSubtitlesFile && <span>{germanSubtitlesFile.filename}</span>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              id={"germanSubtitles"}
              type={"other"}
              customProp={'text/vtt'}
              onIdChange={file => onSubtitlesChange('germanSubtitlesId', file)}
              setPreview={onSetPreview}
            />
          </>
          }

          {/*French*/}
          <FormControlLabel
            control={
              <Checkbox
                style={{color: "#4cc2d5"}}
                checked={frenchSubtitles}
                onChange={() => {
                  onCheckBoxChange('frenchSubtitles', !frenchSubtitles);
                }}
              />
            }
            label={localization.get("form.language.french")}
          />

          {frenchSubtitles &&
          <>
            {frenchSubtitlesFile && <span>{frenchSubtitlesFile.filename}</span>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              id={"frenchSubtitles"}
              type={"other"}
              customProp={'text/vtt'}
              onIdChange={file => onSubtitlesChange('frenchSubtitlesId', file)}
              setPreview={onSetPreview}
            />
          </>
          }


        </>
        }
        <br/>
      </>
      }
      {fileSelector === "audio" &&
      <>
        <h4>{localization.get('audio')}</h4>
        <FormControl>
          <RadioGroup
            name="audiosRadio"
            value={audiosRadio}
            onChange={e => onBatchRadiosChange(e)}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="filepond" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_computer')}/>
            <FormControlLabel value="batch" control={<Radio color="default"/>}
                              label={localization.get('batch_upload.upload_from_platform')}/>
          </RadioGroup>
        </FormControl>

        {audiosRadio === 'filepond' ?
          <div>
            {audio.src && <audio src={audio.src} controls/>}
            <FilePondUploader
              disableForm={disableForm}
              updateDisableForm={updateDisableForm}
              file={audio}
              id={'audio'}
              type={"audio"}
              allowedTypes={["audio/*"]}
              onIdChange={onAudioChange}
              setPreview={onSetPreview}
            />
          </div>
          :
          <>
            <FormControl fullWidth>
              <span>{localization.get('batch_upload.form.select_batch_upload_link')}</span>
              <AsyncSelect
                styles={{
                  menu: base => ({
                    ...base,
                    zIndex: 10
                  })
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0
                })}
                placeholder={localization.get('conversation.filter_users')}
                loadingMessage={() => localization.get('loading')}
                noOptionsMessage={() => localization.get('no_options')}
                onChange={onBatchAudioLinkChange}
                value={selectedBatchAudioLink}
                loadOptions={inputValue => {
                  let filterBy = [{column: "name", filter: inputValue}, {column: "is_talent", filter: isTalent}];

                  return request.batchUpload.getAll({orderBy: {column: "name", type: "ASC"}, filterBy})
                    .then(links => links.map(link => ({value: link.id, label: link.name, token: link.token})))
                }}
                defaultOptions
              />
            </FormControl>

            {selectedBatchAudioLink &&
            <FormControl style={{marginTop: 20}} fullWidth>
              <span>{localization.get('batch_upload.form.select_batch_upload_file')}</span>
              <AsyncSelect
                styles={{
                  menu: base => ({
                    ...base,
                    zIndex: 10
                  })
                }}
                theme={theme => ({
                  ...theme,
                  borderRadius: 0
                })}
                placeholder={localization.get('conversation.filter_users')}
                loadingMessage={() => localization.get('loading')}
                noOptionsMessage={() => localization.get('no_options')}
                onChange={onBatchAudioFileChange}
                value={selectedBatchAudioFile}
                loadOptions={inputValue => {
                  let filterBy = [{column: "filename", filter: inputValue}, {column: "type", filter: 'audio'}];

                  return request.batchUpload.getAllFiles({
                    orderBy: {column: "created_at", type: "DESC"},
                    filterBy
                  }, selectedBatchAudioLink.token)
                    .then(files => files.map(file => ({value: file.id, label: file.filename})))
                }}
                defaultOptions
              />
            </FormControl>
            }
          </>
        }

        <br/>
        <br/>
      </>
      }

      {fileSelector === "binary" &&
      <div>
        <h4>{localization.get('creation.pdf_file')}</h4>
        {binary &&
        <img
          style={{width: '100%', borderRadius: 6, maxWidth: '100px', marginBottom: 10, marginLeft: "calc(50% - 50px)"}}
          src={Pdf}
        />}
        <FilePondUploader
          disableForm={disableForm}
          updateDisableForm={updateDisableForm}
          file={binary}
          id={'binary'}
          allowedTypes={["application/pdf"]}
          onIdChange={onBinaryChange}
          setPreview={onSetPreview}
        />
      </div>
      }

      {fileSelector === "link" &&
      <TextValidator
        style={{width: "100%", marginBottom: "20px"}}
        id="link"
        label={localization.get('form.link')}
        name="link"
        value={link}
        onChange={onChange}
        disabled={disabled}
        errorMessages={[localization.get('validator.is_required')]}
      />
      }

      {fileSelector === "embed" &&
      <>
        <FormLabel style={{marginRight: 20}} focused={false}>{localization.get('form.source')}</FormLabel>
        <RadioGroup
          name="embedSource"
          value={embedSource}
          onChange={e => onBatchRadiosChange(e)}
          style={{flexDirection: "row", display: "contents"}}
        >
          <FormControlLabel value="youtube" control={<Radio color="default"/>}
                            label={localization.get('form.youtube')}/>
          <FormControlLabel value="vimeo" control={<Radio color="default"/>} label={localization.get('form.vimeo')}/>
          <FormControlLabel value="spotify" control={<Radio color="default"/>}
                            label={localization.get('form.spotify')}/>
        </RadioGroup>


        <TextValidator
          style={{width: "100%", marginBottom: "20px"}}
          id="embedUrl"
          label={`${localization.get('form.embed_url')} ${embedSource === 'spotify' ? localization.get('form.embed_spotify') : embedSource === 'vimeo' ? localization.get('form.embed_vimeo') : localization.get('form.embed_youtube')}`}
          name="embedUrl"
          value={embedUrl}
          onChange={onChange}
          disabled={disabled}
          errorMessages={[localization.get('validator.is_required')]}
        />
      </>
      }

      <FormTagSelection tagGroups={tagGroups} onSelectedTagsChanged={onSelectedTagsChanged} disabled={disabled}/>

      <TextValidator
        style={{width: "100%", marginBottom: "20px"}}
        id="metadata"
        label={localization.get('form.hashtags')}
        name="metadata"
        value={metadata}
        onChange={onChange}
        disabled={disabled}
      />
    </div>
  )
}

export default FormContent
